// extracted by mini-css-extract-plugin
export default {"mainHeader":"StopCard_mainHeader__WTMAj Card_mainHeader__qiWH3"};